<template>
    <div>
        <CRow>
            <CCol sm="12" xs="6" class="text-right">
                <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
                    <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
                    <span style="margin-top:20px">Find Services</span>
                </h5>
    
            </CCol>
            <CCol sm="8" class="text-center mt-5" style="width: 90%;background-size: cover; margin: auto;">
                <h3 class="custom-18px text-center">Genie found 1 services match your wishes</h3>
                <CRow class="p-2">
                    <!-- <div style="width:48%;" class="bg-blue-black-card mr-2" @click="GoToSelected()">
                        <div class="text-center">
                            <img style="max-width: 100px;" src="../assets/img/plumber.png" alt="Arrow Left Image" class="p-2" />
                        
                            <h4 class="custom-16px-600 text-white">Plumber</h4>
                            <p class="custom-12px text-white">Lorem ipsum dolor sit amet consectetur. </p>
                        </div>
                    </div>
                    <div style="width:48%;" class="bg-card-grey" @click="GoToSelected()">
                        <div class="text-center">
                            <img style="max-width: 100px;" src="../assets/img/plumber.png" alt="Country Image" class="p-2" />
                            <h4 class="custom-16px-600 text-black">Contractor</h4>
                            <p class="custom-12px text-black">Lorem ipsum dolor sit amet consectetur. </p>
                        </div>
                    </div> -->


                    <div v-for="(categoryGroup, index) in groupedCategories" :key="index">
      <!-- <h4 class="custom-16px-600 text-white">{{ categoryGroup.category }}</h4> -->

      <div v-for="category in categoryGroup.categories" :key="category" style="" class="bg-blue-black-card mr-2" @click="GoToSelected(category)">
        <div class="text-center">
          <img style="max-width: 100px;" src="../assets/img/plumber.png" alt="Arrow Left Image" class="p-2" />
          <h4 class="custom-16px-600 text-white">{{ category }}</h4>
          <p class="custom-12px text-white"></p>
        </div>
      </div>
    </div>
                   
                </CRow>
                <label class="text-center custom-12px mt-2">Note : You can make more than one selection</label>
            </CCol>
        </CRow>
    
    
    
    
    
        <div v-if="isLanguagePopupVisible" class="popup-all backdrop-all" @click="closePopup">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100%" src="../assets/img/pp.png" />
                    <h3 class="custom-16px-500 text-center">Your wishes <br /> Successfully submitted</h3>
                </div>
            </div>
        </div>

        <MainlayoutBottom></MainlayoutBottom>
    </div>
</template>


<script>
import MainlayoutBottom from "../containers/TheBottomCustom.vue";
export default ({
    components: {
    MainlayoutBottom,
  },
    data() {
        return {
            isLanguagePopupVisible: false,
            categories: [],

        }

    },
    computed: {
    groupedCategories() {
      const categoryGroups = {};

      this.categories.forEach(category => {
        const cleanedCategory = category.replace(/['{}]/g, ''); // Remove quotes and curly braces
        const groupName = getCategoryGroupName(cleanedCategory);
        if (!categoryGroups[groupName]) {
          categoryGroups[groupName] = { category: groupName, categories: [] };
        }
        categoryGroups[groupName].categories.push(cleanedCategory);
      });

      return Object.values(categoryGroups);
    },
  },
  created() {
    this.categories = this.$route.query.category ? this.$route.query.category.split(',') : [];
  },
    methods: {
        GoToPrevious() {
            this.$router.go(-1);
        },
        GoToSelected() {
            // Show the popup and backdrop
            this.isLanguagePopupVisible = true;
        },
        closePopup() {
            this.isLanguagePopupVisible = false;
        },

    }
})

function getCategoryGroupName(category) {
  // Implement your logic to determine the group name based on the category
  // For example, you can return the category itself or some transformation
  return category;
}
</script>
